import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import globalTranslations from '../../../i18n/globalTranslations';

class ShowMoreContent extends Component {
  state = {
    isLess: true,
    referenceHeight: 0,
    parentElement: null,
    childElement: null
  };

  toggle = () => {
    this.setState({
      isLess: !this.state.isLess
    });
  };

  setParentElement = (ref) => {
    if (!this.state.parentElement && ref) {
      this.setState({
        parentElement: ref,
        referenceHeight: ref.clientHeight
      });
    }
  };

  setChildElement = (ref) => {
    if (this.state.childElement !== ref) {
      this.setState({
        childElement: ref
      });
    }
  };

  hasOverflow = () => {
    if (this.state.childElement && this.state.parentElement) {
      return this.state.childElement.clientHeight > this.state.referenceHeight;
    }
    return false;
  };

  renderShowMore = () => {
    if (!this.hasOverflow()) {
      return null;
    }

    const showMoreText = this.state.isLess ? (
      <FormattedMessage {...globalTranslations.showMoreText} />
    ) : (
      <FormattedMessage {...globalTranslations.showLessText} />
    );

    return (
      <div className="ShowMoreContent__indicator" onClick={this.toggle}>
        {showMoreText}
      </div>
    );
  };

  render() {
    const { children, ...props } = this.props;
    const { isLess, childElement } = this.state;

    const hasOverflow = this.hasOverflow();
    const style =
      childElement && hasOverflow && !isLess
        ? {
            height: childElement.clientHeight + 'px'
          }
        : null;

    return (
      <Fragment>
        <div
          className={classNames('ShowMoreContent', {
            'ShowMoreContent--overflow-hidden': hasOverflow && isLess,
            'ShowMoreContent--overflow-visible': hasOverflow && !isLess
          })}
          style={style}
          ref={this.setParentElement}
        >
          <div
            className="ShowMoreContent__children"
            ref={this.setChildElement}
            {...props}
          >
            {children}
          </div>
        </div>
        {this.renderShowMore()}
      </Fragment>
    );
  }
}

export default ShowMoreContent;



// WEBPACK FOOTER //
// ./src/components/common/ShowMoreContent/index.jsx